import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import _ from "lodash"
import { eメニュー分類区分 } from "../constant/enum/master"
import { LOCALSTORAGE_PROPERTIES } from "../constant/localstorageProperties"
import { TPage } from "../constant/pages"
import MenuService from "../service/master/menu/menuService"
import {
  TMenuListGetRes,
  TMyMenuInfoDeleteReq,
  TMyMenuInfoPostReq,
  TMyMenuListGetRes,
  Tメニュー,
} from "../service/master/menu/TMenu"
import { TApiResponse } from "../service/TApiResponse"

// TODO:APIできるまでローカルストレージに格納
export type TPageInLocalStorage = Omit<TPage, "Route">

const initialState: {
  categories: string[]
  menuPage: Tメニュー[]
  myPages: Tメニュー[]
} = {
  categories: [],
  menuPage: [],
  myPages: [],
}

// /**
//  * メニュー取得
//  */
export const getMenu = createAsyncThunk<TMenuListGetRes>(
  "menu/get",
  async () => {
    try {
      const menuService = new MenuService()
      const res: TApiResponse<TMenuListGetRes> = await menuService.getList({
        メニュー分類区分コード: eメニュー分類区分.PC,
      })
      return res.data
    } catch (error) {
      throw error
    }
  }
)

/**
 * お気に入り取得
 */
export const getMyMenu = createAsyncThunk<TMyMenuListGetRes>(
  "favorite/get",
  async () => {
    try {
      const menuService = new MenuService()
      const res = await menuService.getMyMenuList({
        メニュー分類区分コード: eメニュー分類区分.PC,
      })
      return res.data
    } catch (error) {
      throw error
    }
  }
)

/**
 * お気に入り追加
 */
export const addMyMenu = createAsyncThunk<
  TMyMenuListGetRes,
  TMyMenuInfoPostReq
>("favorite/add", async (addPageCodeList) => {
  try {
    const menuService = new MenuService()
    await menuService.postMyMenu(addPageCodeList)
    const res = await menuService.getMyMenuList({
      メニュー分類区分コード: eメニュー分類区分.PC,
    })
    return res.data
  } catch (error) {
    throw error
  }
})

/**
 * お気に入り削除
 */
export const deleteMyMenu = createAsyncThunk<
  TMenuListGetRes,
  TMyMenuInfoDeleteReq
>("favorite/delete", async (deletePageCodeList) => {
  try {
    const menuService = new MenuService()
    await menuService.deleteMyMenu(deletePageCodeList)
    const res = await menuService.getMyMenuList({
      メニュー分類区分コード: eメニュー分類区分.PC,
    })
    return res.data
  } catch (error) {
    throw error
  }
})

export const menuSlice = createSlice({
  name: "favorite",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMenu.fulfilled, (state, action) => {
        state.categories = [
          ..._.uniq(action.payload.map((p) => p.メニュー分類コード)),
        ]
        // メニュー一覧のみリロード対策でローカルストレージにメニューコードを確保する
        localStorage.setItem(
          LOCALSTORAGE_PROPERTIES.PERMISSION_PAGES,
          _.uniq(action.payload.map((p) => p.メニューコード)).join(",")
        )
        state.menuPage = [...action.payload]
      })
      .addCase(getMyMenu.fulfilled, (state, action) => {
        state.myPages = [...action.payload]
      })
      .addCase(addMyMenu.fulfilled, (state, action) => {
        state.myPages = [...action.payload]
      })
      .addCase(deleteMyMenu.fulfilled, (state, action) => {
        state.myPages = [...action.payload]
      })
  },
})
